/**
 * Handles the zipcode form inside the dealer form.
 */

define('libs/dealerlocator.zipcodeform',['require','libs/dealerform.zipcodeform','libs/validation'],function(require) {

    'use strict';

    var ZipcodeForm = require('libs/dealerform.zipcodeform'),
        Validator = require('libs/validation');

    var SETTINGS = {
            zipcodeFieldSelector: '.input-postcode',
            listContainerSelector: '.dealer-select-list',
            moreButtonSelector: '.show-more',
            classValid: 'valid',
            chunkSize: 6,
            lazyLoad: true,
            allowEnterKey: false
        },

        EVENT = {
            dealerlistBuild: 'zipcodeform.dealerlist.build',
            dealerlistFailed: 'zipcodeform.dealerlist.error'
        };

    var ZipcodeFormMaps = function(root, settings) {
        this.init.apply(this, arguments);
    };

    ZipcodeFormMaps.prototype = $.extend({}, ZipcodeForm.prototype, {
        init: function(form, settings) {
            this.settings = $.extend({}, SETTINGS, settings || {});
            this.EVENT = EVENT;
            this.root = $(form);
            new Validator(form, {
                validationSelector: '.validate'
            });

            this.field_zipcode = $(this.settings.zipcodeFieldSelector, form);
            this.lookup_url = form.getAttribute('action');
            this.chunk = 0;

            if (this.lookup_url && this.field_zipcode.length) {
                this.root.on('submit', this.doLookup.bind(this));
            }

            if (this.settings.lazyLoad) {
                this.btnMore = $(this.settings.moreButtonSelector);
                if (this.btnMore.length) {
                    this.btnMore.on('click', this.showNextChunk.bind(this));

                    this.root.on('dealerlocator.endOfDealersReached', function() {
                        this.btnMore.remove();
                        $(this.settings.listContainerSelector).removeClass('more-dealers');
                    }.bind(this));
                }
            }
        },

        showNextChunk: function() {
            if (this.chunk * this.settings.chunkSize < this.data.length) {
                this.chunk++;
                this.showChunk(this.chunk);
            }
        }
    });


    return ZipcodeFormMaps;
});

